const key = process.env.REACT_APP_ADDRESS_COMPLETE_KEY;
const application = process.env.REACT_APP_ADDRESS_COMPLETE_APPLICATION;

export function AutoComplete(value, lastId = "") {
  if(lastId !== "") {
    lastId = `&lastId=${lastId}`;
  }
  return fetch(`https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3.ws?key=${key}&SearchTerm=${value}${lastId}&Country=CAN`).then(response => {
    return response.json()
  }).then(json => {      
    return json;
  }).catch(error => {
    console.log(error);
  });
}

export function AutoCompleteFind(value) {
  return fetch(`https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/AutoCompleteFind/v1.00/json3.ws?key=${key}&Id=${value}`).then(response => {
    return response.json()
  }).then(json => {      
    return json;
  }).catch(error => {
    console.log(error);
  });
}

export function RetrieveById(value) {
  return fetch(`https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/RetrieveById/v1.00/json3.ws?key=${key}&Id=${value}&Application=${application}`).then(response => {
    return response.json()
  }).then(json => {      
    return json;
  }).catch(error => {
    console.log(error);
  });
}


// WEBPACK FOOTER //
// ./src/utils/AddressComplete.js